import { render } from "./addressSelection.vue?vue&type=template&id=05485a62"
import script from "./addressSelection.vue?vue&type=script&lang=js"
export * from "./addressSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__